/**
 * 数据请求处理中心
 * @creater liux
 * @Email   liuxing@autobio.com.cn
 * @Date    2019年8月8日 10:00:00
 */
import Vue from 'vue';
import axios from 'axios';
// import store from '@/store';
import qs from 'qs';
import { reject } from 'lodash';

let isRefreshing = true;
let subscribers = [];
//取消请求Token
const CancelToken = axios.CancelToken;
const source = CancelToken.source();
//请求实例
const http = axios.create({
  cancelToken: source.token,
  baseURL: process.env.VUE_APP_BASE_API,
  // baseURL: '/',
});
let authURL = process.env.VUE_APP_TOKEN_API;
// 超时
http.defaults.timeout = 30 * 1000;
// 请求头数据格式
// axios.defaults.headers.post['Content-Type'] =
// 'application/x-www-form-urlencoded;charset=UTF-8';
// test
// 配置文档baseurl设置，根据项目需求修改
// switch (process.env.NODE_ENV) {
//   case 'development':
//     http.defaults.baseURL = '/';
//     authURL = Vue.prototype.$config.authUrl.default;
//     break;
//   case 'test':
//     http.defaults.baseURL = Vue.prototype.$config.baseURL.test;
//     authURL = Vue.prototype.$config.authUrl.test;
//     break;
//   case 'bak':
//     http.defaults.baseURL = Vue.prototype.$config.baseURL.productionBak;
//     authURL = Vue.prototype.$config.authUrl.productionBak;
//     break;
//   default:
//     http.defaults.baseURL = Vue.prototype.$config.baseURL.production;
//     authURL = Vue.prototype.$config.authUrl.production;
//     break;
// }
// let allowRepeat = ['/api/public/blob/assumerole', '/api/public/materials/toplist'];
// let pending = []; //声明一个数组用于存储每个ajax请求的取消函数和ajax标识
// let cancelToken = axios.CancelToken;
// let removeRepeatUrl = (ever) => {
//   for (let p in pending) {
//     if (pending[p].u === ever.url + '&' + ever.method) {
//       //当当前请求在数组中存在时执行函数体
//       pending[p].f(); //执行取消操作
//       pending.splice(p, 1); //把这条记录从数组中移除
//     }
//   }
// };
// 请求拦截
http.interceptors.request.use(
  (config) => {
    //可根据项目需求添加逻辑
    if (window.isUnVaild) {
      return Promise.reject();
    }
    if (!config.noLoading) loadingGif(true);
    // let repeatFlag = true;
    // let url = config.url;
    // allowRepeat.forEach((val) => {
    //   if (val == url) {
    //     repeatFlag = false;
    //   }
    // });
    // if (repeatFlag) {
    //   //在一个ajax发送前执行一下取消操作
    //   removeRepeatUrl(config);
    //   config.cancelToken = new cancelToken((c) => {
    //     // 自定义唯一标识
    //     pending.push({
    //       u: config.url + '&' + config.method,
    //       f: c,
    //     });
    //   });
    // }
    config.headers['Authorization'] = Vue.prototype.$userInfo.getLoginInfo().token;
    return config;
  },
  (err) => Promise.reject(err)
);
// 响应拦截
http.interceptors.response.use(
  (response) => {
    if (!response.config.noLoading) loadingGif(false);
    // removeRepeatUrl(response.config); //在一个ajax响应后再执行一下取消操作，把已经完成的请求从pending中移除
    //凭证相关，根据项目需求定义
    var errorCodes = [
      Vue.prototype.$config.ResultCode.AUTHENTICATION_ERROR_CODE,
      Vue.prototype.$config.ResultCode.UNAUTHENTICATION_CODE,
      Vue.prototype.$config.ResultCode.EXPIREDCREDENTIALS_CODE,
      Vue.prototype.$config.ResultCode.UNKNOWNACCOUNT_CODE,
    ];
    if (response.config.ignore) {
      //特殊接口，例如：GET 文件、 第三方接口合作
      //TODO 特殊接口处理
      return response;
    } else if (response.data.code == Vue.prototype.$config.ResultCode.SUCCESS_CODE) {
      //成功回调
      return response.data;
    } else if (response.items) {
      return response.items;
    } else if (response.data && response.data.items) {
      return response.data;
    } else if (Array.isArray(response.data) && typeof response.data.code === 'undefined') {
      return response;
    } else if (response.data && response.data.id && typeof response.data.code === 'undefined') {
      return response;
    } else if (response.data === '' && typeof response.data.code === 'undefined') {
      return response;
    } else if (errorCodes.indexOf(response.data.code) != -1) {
      //凭证错误失效
      //未提示，进行页面提示
      if (window.isUnVaild) {
        Vue.prototype.$alert(response.data.msg || '凭证失效!', '提示', {
          callback: () => {
            Vue.prototype.$userInfo.goLoginPage();
            window.isUnVaild = true;
          },
        });
      }
    } else if (response.data.code == '' || response.data.code == null) {
      Vue.prototype.$message.error(response.data.message || '');
    } else {
      //接口错误message提示
      if (!response.config.noAlert) {
        Vue.prototype.$message.error(response.data.message || '');
      }
      return Promise.reject(response); //后台message提示
    }
  },
  (err) => {
    if (!err.config.noLoading) loadingGif(false);
    const { response } = err;
    // 状态码判断
    switch (response.status) {
      case 401:
        if (getRefreshToken()) {
          if (isRefreshing) {
            getNewToken();
          }
          isRefreshing = false;
          let config = err.response.config;
          // 这个Promise函数很关键
          const retryOriginalRequest = new Promise((resolve) => {
            addSubscriber(() => {
              config.headers.Authorization = sessionStorage.getItem('token');
              axios
                .request(config)
                .then((res) => {
                  resolve(res.data);
                })
                .catch((err) => {
                  reject(err);
                  Vue.prototype.$message.error(err.response.data.error.message || '网络错误,请稍后再试!');
                });
            });
          });
          return retryOriginalRequest;
        } else {
          Vue.prototype.$message.error('登录过期,请重新登录!');
          Vue.prototype.$mgr.signoutRedirect();
        }
        break;
      // 404请求不存在
      // case 404:
      //   Vue.prototype.$message.error('请求的资源不存在');
      //   break;
      default:
        Vue.prototype.$message.error(err.response.data.error.message || '网络错误,请稍后再试!');
        return Promise.reject(err);
    }
  }
);

function onAccessTokenFetched() {
  subscribers.forEach((callback) => {
    callback();
  });
  subscribers = [];
}

function addSubscriber(callback) {
  subscribers.push(callback);
}
window.loadingNumber = 0;

function loadingGif(flag) {
  if (flag) {
    window.loadingNumber++;
    if (!document.getElementById('loadingContainer')) {
      var node = document.createElement('div');
      node.id = 'loadingContainer';
      node.innerHTML = '<img src="/assets/loading.gif">';
      document.body.appendChild(node);
    }
  } else {
    window.loadingNumber--;
    if (!window.loadingNumber) {
      var idObject = document.getElementById('loadingContainer');
      if (idObject != null) idObject.parentNode.removeChild(idObject);
    }
  }
}

function getNewToken() {
  return new Promise((resolve, reject) => {
    let strParams = qs.stringify({
      client_id: 'OecClient',
      client_secret: 'C60674E11F224B15B6A1725203E7C9A2',
      grant_type: 'refresh_token',
      refresh_token: localStorage.getItem('refresh_token'),
    });
    axios
      .request({
        baseURL: authURL,
        headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
        url: '/connect/token',
        method: 'post',
        data: strParams,
      })
      .then((res) => {
        isRefreshing = true;
        const data = res.data;
        localStorage.setItem('refresh_token', data.refresh_token);
        sessionStorage.setItem('token', data.token_type + ' ' + data.access_token);
        onAccessTokenFetched();
        resolve(data);
      })
      .catch((err) => {
        Vue.prototype.$message.error('登录过期,请重新登录!');
        Vue.prototype.$mgr.signoutRedirect();
        // localStorage.removeItem("refresh_token");
        // localStorage.removeItem("logon_time");
        sessionStorage.removeItem('token');
        reject(err);
      });
  });
}
async function doRequest(error) {
  try {
    const data = await getNewToken();
    let { token_type: tokenType, access_token: accessToken } = data;
    let token = tokenType + ' ' + accessToken;
    let config = error.response.config;
    config.headers.Authorization = token;
    // const res = await axios.request(config)
    // return res.data;
    // 这个Promise函数很关键
    const retryOriginalRequest = new Promise((resolve) => {
      addSubscriber(() => {
        resolve(axios.request(config));
      });
    });
    return retryOriginalRequest;
  } catch (err) {
    // Vue.prototype.$message.error('登录过期,请重新登录!');
    // Vue.prototype.$mgr.signoutRedirect();
    return false;
  }
}

function getRefreshToken() {
  // let currentTime = new Date().getTime();
  // let userLoginTime = localStorage.getItem('login-time');
  // let timeOut = 20 * 24 * 60 * 60 * 1000; // 30天一个refreshtoken过期
  // let differ = currentTime - userLoginTime;
  if (localStorage.getItem('refresh_token')) {
    return true;
  } else {
    return false;
  }
}
export default {
  http: http,
  baseURL: http.defaults.baseURL,
  //get
  get(url, params = {}, config = {}) {
    return http.get(
      url,
      Object.assign(
        {
          params: params,
        },
        config
      )
    );
  },
  //post
  post(url, data = {}, config = {}) {
    return http.post(url, data, config);
  },
  //put
  put(url, data = {}, config = {}) {
    return http.put(url, data, config);
  },
  //delete
  delete(url, data = {}) {
    return http.delete(url, data);
  },
  //patch
  patch(url, data = {}, config = {}) {
    return http.patch(url, data, config);
  },
  //delete by id
  deleteTo(url, data = {}) {
    return http.delete(url + `/${data.id}`);
  },
};
